import React from "react";
import WrapperContainer from "../../utilities/WrapperContainer";
import { Link } from "react-router-dom";
import preparefile from "../../../assests/images/preparefile.png";
import questionmark from "../../../assests/images/questionmark.svg";
import tutorialDemo1 from "../../../assests/images/tutorialDemo1.svg";
import tutorialDemo2 from "../../../assests/images/tutorialDemo2.svg";
import tutorialDemo3 from "../../../assests/images/tutorialDemo3.svg";
import tutorialResult from "../../../assests/images/tutorialResult.svg";
import tutorialUpload1 from "../../../assests/images/tutorialUpload1.svg";
import tutorialUpload2 from "../../../assests/images/tutorialUpload2.svg";
import tutorialMyData1 from "../../../assests/images/tutorialMyData1.svg";
import tutorialMyData2 from "../../../assests/images/tutorialMyData2.svg";
import tutorialMyData3 from "../../../assests/images/tutorialMyData3.svg";
import tutorialMyDataResult from "../../../assests/images/tutorialMyDataResult.svg";
import tick from "../../../assests/images/tick.svg";
import failed from "../../../assests/images/failed.svg";
import SyncIcon from "@mui/icons-material/Sync";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import Table from "../Fractions/Table";

export function TutorialsText() {
  const StepItem = ({ stepnumber, text }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        marginBottom: "1rem",
      }}
    >
      <div
        style={{
          width: "34px",
          height: "34px",
          borderRadius: "50%",
          backgroundColor: "#d4d4d4",
          // backgroundColor: "#e6f0f8",
          color: "#0a1f33",
          fontSize: "21px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {stepnumber}
      </div>
      <span style={{ fontSize: "24px" }}>{text}</span>
    </div>
  );
  return (
    <>
      <p className="para-dark-grey">
        In this tutorial, you will learn how to run{" "}
        <strong>iSort&trade; Fractions</strong> in your <strong>web browser</strong>,
        starting with demo datasets and then applying the workflow to your own
        data.
      </p>
      <p className="para-dark-grey">
        If you will be running <strong>iSort&trade; Fractions locally</strong>{" "}
        with a <strong>Docker</strong> version, follow the <strong>user guides</strong> on <Link to="/runlocally" style={{ textDecoration: "none" }}>
        <strong>Run&trade; iSort Locally</strong></Link> page.
      </p>
      <p className="para-dark-grey">
        Contact <a href="mailto:support@cibermed.com">support@cibermed.com</a>{" "}
        if you have any questions.
      </p>
      <div>
        <div>
          <div className="border-0 border-bottom border-top">
            <button
              className="custom-title accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0 pe-xl-3"
              style={{ margin: "8px 0" }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseBeforeRunning"
              aria-expanded="false"
              aria-controls="collapseBeforeRunning"
            >
              Before Running iSort&trade; Fractions
              <span className="icon-toggle ms-auto ps-3 home-card-title"></span>
            </button>
            <div
              id="collapseBeforeRunning"
              className="accordion-collapse collapse px-3 px-xl-4"
              aria-labelledby="headingBeforeRun"
            >
              <div>
                <p>
                  A valid token is required to run iSort&trade; Fractions.
                  Please see{" "}
                  <Link to="/tokens" style={{ textDecoration: "none" }}>
                    Tokens
                  </Link>{" "}
                  for details.
                </p>
              </div>
            </div>
          </div>

          <div className="border-0 border-bottom">
            <button
              className="custom-title accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0 pe-xl-3"
              style={{ margin: "8px 0" }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseDemoData"
              aria-expanded="false"
              aria-controls="collapseDemoData"
            >
              Run iSort&trade; Fractions with Demo Data
              <span className="icon-toggle ms-auto ps-3 home-card-title"></span>
            </button>
            <div
              id="collapseDemoData"
              className="accordion-collapse collapse px-3 px-xl-4"
              aria-labelledby="headingDemoData"
            >
              <div>
                <p>
                  Demo data runs are free and do not impact sample counter of
                  your token.
                  <br />
                  Go to <b>Main Menu</b> on the left, and select{" "}
                  <b>Run iSort&trade; on Browser</b>.
                  <ol>
                    <li>
                      Select <b>iSort&trade; Fractions</b>
                    </li>
                    <li>
                      Select <b>Demo Data</b>
                    </li>
                    <li>
                      Select <b>Demo Data files for Fractions (5 samples)</b>
                    </li>
                    <li>
                      Select <b>your token</b>
                    </li>
                    <li>
                      Enter <b>Run Name</b> (optional) up to 25 characters.
                    </li>
                    <li>
                      Press <b>Continue</b>
                    </li>
                  </ol>
                  <img
                    src={tutorialDemo1}
                    alt="iSort Fractions Demo Step 1"
                    className="tutorial-img"
                  />
                  <ol start="7">
                    <li>
                      On the next screen, preview the details and press{" "}
                      <b>Continue</b> to run the job
                    </li>
                  </ol>
                  <img
                    src={tutorialDemo2}
                    alt="iSort Fractions Demo Step 2"
                    className="tutorial-img mt-0"
                  />
                  <ol start="8">
                    <li>
                      You will get the job creation confirmation and job ID for
                      the future reference. You can start another job from here
                      or go to dashboard to check the job status
                    </li>
                  </ol>
                  <img
                    src={tutorialDemo3}
                    alt="ISort Fractions Demo Job Confirmation"
                    className="tutorial-img"
                  />
                </p>

                <p>
                  To view the job status or to download the results, go to{" "}
                  <b>Main Menu</b>, then select <b>Results</b>.
                  <ol>
                    <li>
                      Click the <b>View Result icon</b> to see the details such
                      as the job parameters.
                    </li>
                    <li>
                      Click on <b>Download icon</b> to download the results.
                    </li>
                  </ol>
                </p>
                <img
                  src={tutorialResult}
                  alt="Results View"
                  className="tutorial-img"
                  style={{ padding: "16px", paddingTop: "20px" }}
                />
              </div>
            </div>
          </div>

          <div className="border-0 border-bottom">
            <button
              className="custom-title accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0 pe-xl-3"
              style={{ margin: "8px 0" }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseYourData"
              aria-expanded="false"
              aria-controls="collapseYourData"
            >
              Run iSort&trade; Fractions with Your Data
              <span className="icon-toggle ms-auto ps-3 home-card-title"></span>
            </button>
            <div
              id="collapseYourData"
              className="accordion-collapse collapse px-3 px-xl-4"
              aria-labelledby="headingYourData"
            >
              <div>
                <StepItem
                  stepnumber="&#8544;"
                  text="Prepare your bulk expression file"
                />
                <p>
                  Prepare your bulk expression file according to the
                  requirements listed below.
                  <ol>
                    <li>
                      The file must be in a <strong>tab-delimited text format</strong>. The first
                      column must contain gene names and the first row should
                      contain sample names.
                    </li>
                    <li>
                      The <strong>sample names must be unique</strong>.
                      <br />
                      Number of samples should not exceed more than 1000
                      samples.
                      <br />
                      If your data contains more than 1000 samples, split the
                      bulk expression file.
                    </li>
                    <li>
                      Gene names must be <strong><u>HUGO</u>-compliant gene names.
                        Ensembl IDs cannot be used</strong>. If multiple Ensembl IDs are
                      converted to a single gene name, sum the expression
                      values.
                    </li>
                    <li>
                      For RNA-seq data, the <strong>expression values must be in TPM</strong>
                      (transcripts per million), non-log, <strong>without any missing
                        values</strong>.
                    </li>
                    <li>
                      For microarray data, iSort&trade; will apply quantile
                      normalization which is described later.
                    </li>
                    <li>
                      If your data set exhibits significant batch effects (e.g.,
                      due to different library prep methods, different tissue
                      types, etc.), separate the bulk expression file
                      accordingly and run iSort&trade; separately.
                    </li>
                    <li>
                      Each bulk expression file should contain at least 3
                      samples. For effective batch correction, 5 or more samples
                      are ideal.
                    </li>
                  </ol>
                  An example of a bulk expression file is shown below. While
                  shown in Excel for clarity, the actual file you upload must be
                  a tab-separated text file.
                </p>
                <img
                  src={preparefile}
                  alt="Prepare bulk expression file"
                  className="tutorial-img mt-0 p-3"
                  style={{ maxWidth: "min( 1122px , 100% )" }}
                />
                <StepItem
                  stepnumber="&#8545;"
                  text="Upload your bulk expression file (gene expression matrix)"
                />
                <p>
                  <ol>
                    <li>
                      Under the <b>Main Menu</b>, select <b>Upload Files</b>.
                    </li>
                    <li>
                      Upload your bulk expression file either by <strong>Click to Upload</strong>
                      or by simply drag-and-drop the file.
                      <br />
                      You can upload multiple files.
                    </li>
                  </ol>
                  <img
                    src={tutorialUpload1}
                    alt="Upload File Step 1"
                    className="tutorial-img"
                  />
                  <ol start="3">
                    <li>
                      Name the file under "File Name Alias" for later use. When
                      you are ready, press the upload button
                    </li>
                  </ol>
                  <img
                    src={tutorialUpload2}
                    alt="Upload File Step 2"
                    className="tutorial-img"
                  />
                </p>

                <StepItem
                  stepnumber="&#8546;"
                  text="Configure your job and run"
                />
                <p>
                  From the <b>Main Menu</b>, select{" "}
                  <b>Run iSort&trade; on Browser</b>
                  <ol>
                    <li>
                      Select{" "}
                      <b>
                        iSort&trade; Fractions (iSort&trade; HiRes is currently
                        offered only as a stand-alone version)
                      </b>
                    </li>
                    <li>
                      Select <b> My Data</b>
                      <br />
                      <b>Signature Matrix:</b> Select "Blood" or "Tissue" mode.
                      See the complete cell type list below.
                      <br />
                      <b>Bulk Expression File:</b> Select your gene expression
                      data file to analyze.
                      <br />
                      <b>Platform:</b> Specify your data type: RNA-Seq or
                      miccroarray data. If "microarray" is selected, quantile
                      normalization will be automatically applied.
                      <br />
                      <b>Sequence Type:</b> This is for informational purposes
                      only. Your choice will not impact the computation method.
                      <br />
                      <b>Token:</b> If you have multiple tokens, select which
                      token you'd like to use.
                      <br />
                      <b>Run Name:</b> Free text up to 25 charactes.
                    </li>
                    <li>
                      Press <b>Continue.</b>
                    </li>
                  </ol>
                  <img
                    src={tutorialMyData1}
                    alt="iSort Fractions Custom Data Step 1"
                    className="tutorial-img"
                  />
                  <Table loggedIn={true} center={true} />
                  <br />
                  <ol start="4">
                    <li>
                      Then on the next screen, confirm all the details and press{" "}
                      <b>Continue</b> if the details are correct or you can edit
                      them by pressing the <b>Back</b> button.
                      <br />
                      There might be some waiting time depending on the server
                      load (up to 5 - 10 min). Once the computation is started,
                      the following show the approximate run time, which varies
                      depending on the server load.
                      <br />
                      50 samples: 1 - 3 min
                      <br />
                      100 samples: 2 - 5 min
                      <br />
                      200 samples: 3 - 7 min
                    </li>
                  </ol>
                  <img
                    src={tutorialMyData2}
                    alt="iSort Fractions Custom Data Step 2"
                    className="tutorial-img mt-0"
                  />
                  <ol start="5">
                    <li>
                      You will get the job creation confirmation and job ID for
                      the future reference. You can start another job from here
                      or go to dashboard to check the job status.
                    </li>
                  </ol>
                  <img
                    src={tutorialMyData3}
                    alt="iSort Fractions Custom Data Job Confirmation"
                    className="tutorial-img"
                  />
                  <ol start="6">
                    <li>
                      To check the job status, select <b>Results</b> from the{" "}
                      <b>Main Menu</b> on the left.
                      <br />
                      You can also check the status by going to your{" "}
                      <b>Dashboard</b>.<br />
                      <b>
                        You will receive an email when the job is completed.
                      </b>
                    </li>
                  </ol>
                </p>
                <StepItem
                  stepnumber="&#8547;"
                  text="Review and download results"
                />
                <p>
                  <ol>
                    <li>
                      Select <b>Results</b> from the <b>Main Menu</b> on the
                      left.
                    </li>
                    <li>
                      Under status, you will see
                      <ol type="a">
                        <li>
                          A green check mark <img src={tick} alt="tick" /> for a
                          completed job.{" "}
                        </li>
                        <li>
                          A waiting icon <PendingActionsIcon /> for a pending
                          (waiting) job.
                        </li>
                        <li>
                          A red warning mark <img src={failed} alt="failed" />{" "}
                          for an error.
                        </li>
                        <li>
                          A processing icon <SyncIcon /> for the currently
                          processing job.
                        </li>
                      </ol>
                    </li>
                    <li>
                      Under Actions:
                      <ol type="a">
                        <li>Click View Results icon to see results</li>
                        <li>Click Download icon to download the results.</li>
                        <li>
                          Be careful to use the Delete button, as you cannot
                          recover the results file once deleted.
                          <br />
                          Make sure to download the results files before you
                          delete them.
                        </li>
                      </ol>
                    </li>
                  </ol>
                  <img
                    src={tutorialMyDataResult}
                    className="tutorial-img p-0"
                    style={{ maxWidth: "min( 1122px , 100% )" }}
                    alt="my data result"
                  />
                </p>
                <div
                  className="text-white hero-section"
                  style={{ textAlign: "center" }}
                >
                  <img src={questionmark} alt="question mark" />
                  <p
                    style={{
                      fontSize: "24px",
                      paddingTop: "30px",
                      marginBottom: "10px",
                    }}
                  >
                    Still have questions?
                  </p>
                  <p>
                    <Link to="/contact" className="text-white">
                      <u>Contact customer support</u>
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function Tutorials() {
  return (
    <>
      <WrapperContainer
        loggedin={true}
        title="Tutorials"
        content={<TutorialsText />}
      />
    </>
  );
}
